import { createSlice } from '@reduxjs/toolkit';
import { IDailyWeather } from 'Shared/Types/dailyWeather';
import { getWeeklyWeather } from './reducer';
import { RootState } from 'Redux/store';

interface IWeatherState {
  weeklyWeather: IDailyWeather[];
  error?: string | null;
  loading: boolean;
}

const initialState: IWeatherState = {
  weeklyWeather: [],
  error: null,
  loading: false,
};

const weatherSlice = createSlice({
  name: 'weather',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWeeklyWeather.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getWeeklyWeather.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getWeeklyWeather.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.weeklyWeather = action.payload || [];
    });
  },
});

export const selectWeatherLoading = (state: RootState) => state.weather.loading;
export const selectWeatherError = (state: RootState) => state.weather.error;
export const selectWeeklyWeather = (state: RootState) =>
  state.weather.weeklyWeather;

export default weatherSlice;
